import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { MatOption, MatOptionSelectionChange } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { ReplaySubject, Subject, Subscription, debounceTime, takeUntil } from 'rxjs';
import { MeritorService } from '../meritor.service';
import { multiSelectAllTriggerLabel } from 'src/app/modules/shared/utils/multi-select-all-trigger.util';

@Component({
  selector: 'app-drop-down-meritor',
  templateUrl: './drop-down-meritor.component.html',
  styleUrls: ['./drop-down-meritor.component.scss']
})
export class DropDownMeritorComponent implements OnInit, AfterViewInit {
  @Input() formDetails: any = {};
  @Input() selectedValues: any = {};
  @Input() reset: number = 0;
  @Output() onReset: EventEmitter<number> = new EventEmitter();
  @Input() currentPage: string = '';
  @Output() onSelectFilter: any = new EventEmitter<any>();
  searchUserForm!: FormGroup;
  private readonly ALL_TOKEN = 'All';
  private readonly filterEmit$ = new Subject<{ type: string; value: any }>();
  @ViewChild('allProductGroupSelected') private allProductGroupSelected!: MatOption;
  @ViewChild('allChannelSelected') private allChannelSelected!: MatOption;
  @ViewChild('allCustomerGroupSelected') private allCustomerGroupSelected!: MatOption;
  @ViewChild('allProductCategorySelected') private allProductCategorySelected!: MatOption;
  @ViewChild('allDDSPDCOthersSelected') private allDDSPDCOthersSelected!: MatOption;
  @ViewChild('allRegionSelected') private allRegionSelected!: MatOption;
  @ViewChild('allPartsSelected') private allPartsSelected!: MatOption;

  @ViewChild('productGroup', { read: MatSelect }) private productGroupSelect?: MatSelect;
  @ViewChild('channel', { read: MatSelect }) private channelSelect?: MatSelect;
  @ViewChild('certification', { read: MatSelect }) private certificationSelect?: MatSelect;
  @ViewChild('bill_to_name', { read: MatSelect }) private billToNameSelect?: MatSelect;
  @ViewChild('ddsPdcOhters', { read: MatSelect }) private ddsPdcOhtersSelect?: MatSelect;
  @ViewChild('part_number', { read: MatSelect }) private partNumberSelect?: MatSelect;

  public searchProductGroup: FormControl = new FormControl();
  public searchChannel: FormControl = new FormControl();
  public searchCustomerGroup: FormControl = new FormControl();
  public searchProductCategory: FormControl = new FormControl();
  public searchDDSPDCOthers: FormControl = new FormControl();
  public searchRegion: FormControl = new FormControl();
  public searchParts: FormControl = new FormControl();

  protected _onDestroy = new Subject<void>();

  public filteredProductGroup: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredChannel: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredCustomerGroup: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredProductCategory: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredDDSPDCOthers: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredRegion: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public filteredParts: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  public partNos: ReplaySubject<any[]> = new ReplaySubject<any[]>();

  private subscription: Subscription;
  private clicks = new Subject();
  data: any = {};
  qparam: any;
  page: number = 1;
  size: number = 100;
  more: boolean = true;
  path = location.pathname;
  rowHeight: number = 30;
  gutterSize: number = 5;
  loadMoreClk: boolean = false;
  constructor(
    private fb: FormBuilder,
    private cdr: ChangeDetectorRef,
    private service: MeritorService
  ) {
    this.subscription = Subscription.EMPTY;
  }

  resetButton() {
    this.onReset.emit(this.reset);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.filteredProductGroup.next(this.formDetails['product_group']?.slice());
    this.filteredChannel.next(this.formDetails['channel']?.slice());
    this.filteredCustomerGroup.next(this.formDetails['certification']?.slice());
    this.filteredProductCategory.next(this.formDetails['bill_to_name']?.slice());
    this.filteredDDSPDCOthers.next(this.formDetails['ecc']?.slice());
    this.filteredRegion.next(this.formDetails['main_region']?.slice());
    this.filteredParts.next(this.formDetails['part_number']?.slice());
    this.partNos.next(this.formDetails['part_number']?.slice(0,10));

    if (this.reset > 0) {
      this.data.type = '';
      this.searchUserForm.controls.userProductGroup.patchValue([this.ALL_TOKEN]);
      this.searchUserForm.controls.userChannel.patchValue([this.ALL_TOKEN]);
      this.searchUserForm.controls.userCustomerGroup.patchValue([this.ALL_TOKEN]);
      this.searchUserForm.controls.userProductCategory.patchValue([this.ALL_TOKEN]);
      this.searchUserForm.controls.userDDSPDCOthers.patchValue([this.ALL_TOKEN]);
      this.searchUserForm.controls.userRegion.patchValue([this.ALL_TOKEN]);
      this.searchUserForm.controls.userParts.patchValue([this.ALL_TOKEN]);

      this.reset = 0;
    }
    this.expandAllSelectionsIfNeeded();
  }
  ngAfterViewInit(): void {
    this.filterEmit$
      .pipe(debounceTime(600), takeUntil(this._onDestroy))
      .subscribe((payload) => this.onSelectFilter.emit(payload));

    this.expandAllSelectionsIfNeeded();
  }

  ngOnInit(): void {
    this.searchUserForm = this.fb.group({
      userProductGroup: new FormControl([this.ALL_TOKEN]),
      userChannel: new FormControl([this.ALL_TOKEN]),
      userCustomerGroup: new FormControl([this.ALL_TOKEN]),
      userProductCategory: new FormControl([this.ALL_TOKEN]),
      userDDSPDCOthers: new FormControl([this.ALL_TOKEN]),
      userRegion: new FormControl([this.ALL_TOKEN]),
      userParts: new FormControl([this.ALL_TOKEN]),
    });
    setTimeout(() => this.expandAllSelectionsIfNeeded(), 0);

    this.searchProductGroup.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterProductGroup();
      });
    this.searchChannel.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterChannel();
      });
    this.searchCustomerGroup.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterCustomerGroup();
      });
    this.searchProductCategory.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterProductCategory();
      });
    this.searchDDSPDCOthers.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterDDSPDCOthers();
      });
    this.searchRegion.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterRegion();
      });
    this.searchParts.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterParts();
      });
   
  }

  changeFilter(eventValue: any, filter: string) {
    const controlName = this.getControlName(filter);
    const allValues = this.getAllValues(filter);
    const raw: string[] = Array.isArray(eventValue) ? eventValue : [];

    let { controlValue } = this.normalizeSelection(raw, allValues);
    controlValue = this.collapsePartialAllToken(controlValue, allValues);
    const emittedValue = this.deriveEmittedMulti(controlValue, filter);

    if (controlName && this.searchUserForm?.controls?.[controlName]) {
      this.searchUserForm.controls[controlName].setValue([...controlValue], {
        emitEvent: false,
      });
    }

    this.scheduleAllMatOptionSync(filter);

    this.data = { value: emittedValue, type: filter };
    this.filterEmit$.next(this.data);
  }

  /** When the panel opens, fix inconsistent ["All", ...partial] and re-sync the "All" row. */
  onFilterMultiOpened(isOpen: boolean, filter: string): void {
    if (!isOpen) return;
    const controlName = this.getControlName(filter);
    if (!controlName || !this.searchUserForm?.controls?.[controlName]) return;
    const allValues = this.getAllValues(filter);
    let controlValue =
      (this.searchUserForm.controls[controlName].value as string[]) || [];
    controlValue = this.collapsePartialAllToken([...controlValue], allValues);
    this.searchUserForm.controls[controlName].setValue([...controlValue], {
      emitEvent: false,
    });
    this.scheduleAllMatOptionSync(filter);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this._onDestroy.next();
    this._onDestroy.complete();
    this.filterEmit$.complete();
  }

  protected filterProductGroup() {
    // get the search keyword
    let search = this.searchProductGroup.value;

    search = search.toLowerCase();
    // filter
    this.filteredProductGroup.next(
      this.formDetails['product_group'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterChannel() {
    // get the search keyword
    let search = this.searchChannel.value;

    search = search.toLowerCase();
    // filter
    this.filteredChannel.next(
      this.formDetails['channel'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterCustomerGroup() {
    // get the search keyword
    let search = this.searchCustomerGroup.value;

    search = search.toLowerCase();
    // filter
    this.filteredCustomerGroup.next(
      this.formDetails['certification'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterProductCategory() {
    // get the search keyword
    let search = this.searchProductCategory.value;

    search = search.toLowerCase();
    // filter
    this.filteredProductCategory.next(
      this.formDetails['bill_to_name'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterDDSPDCOthers() {
    // get the search keyword
    let search = this.searchDDSPDCOthers.value;

    search = search.toLowerCase();
    // filter
    this.filteredDDSPDCOthers.next(
      this.formDetails['ecc'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterRegion() {
    // get the search keyword
    let search = this.searchRegion.value;

    search = search.toLowerCase();
    // filter
    this.filteredRegion.next(
      this.formDetails['main_region'].filter(
        (item) => item.value.toLowerCase().indexOf(search) > -1
      )
    );
  }
  protected filterParts() {
    // // get the search keyword
    // let search = this.searchParts.value;

    // search = search.toLowerCase();
    // // filter
    // this.filteredParts.next(
    //   this.formDetails['part_number'].filter(
    //     (item) => item.value.toLowerCase().indexOf(search) > -1
    //   )
    // );

    // get the search keyword
    let search = this.searchParts.value;
    search = search.toUpperCase();
    this.qparam = {
      product_group: this.selectedValues.product_group,
      channel: this.selectedValues.channel,
      certification: this.selectedValues.certification,
      bill_to_name: this.selectedValues.bill_to_name,
      ecc: this.selectedValues.ecc,
      main_region: this.selectedValues.main_region,
      current_dropdown: 'part_number',
    };
      if (search !== '') {
        this.service
          .searchMeritorPartsDropdown(this.qparam, search)
          .subscribe((results) => {
            const resp = [...new Set(results.part_number)];

            this.formDetails['part_number'] =
              resp && resp.map((i: any) => ({ viewValue: i, value: i }));
            this.filteredParts.next(this.formDetails['part_number']);
          });
        this.cdr.detectChanges();
      }
    
  }

  // public filterPartsMulti() {
  //   // get the search keyword
  //   let search = this.partsMultiFilterCtrl.value;
  //   search = search.toUpperCase();
  //   this.qparam = {
  //     main_region: this.selectedValues.main_region,
  //     wpt: this.selectedValues.wpt,
  //     customer: this.selectedValues.customer,
  //     engine_model: this.selectedValues.engine_model,
  //     ecc: this.selectedValues.ecc,
  //     manufacturer: this.selectedValues.manufacturer,
  //     current_dropdown: 'parts',
  //   };
  //   if (this.currentPage == 'ebu') {
  //     if (search !== '') {
  //       this.service
  //         .searchDropdown(this.qparam, search)
  //         .subscribe((results) => {
  //           const resp = [...new Set(results.parts)];

  //           this.formDetails['parts'] =
  //             resp && resp.map((i: any) => ({ viewValue: i, value: i }));
  //           this.filteredPartsMulti.next(this.formDetails['parts']);
  //         });
  //       this.cdr.detectChanges();
  //     }
  //   } else {
  //     this.filteredPartsMulti.next(
  //       this.formDetails['parts'].filter(
  //         (item) => item.value.toLowerCase().indexOf(search) > -1
  //       )
  //     );
  //   }
  // }

  multiSelectTriggerLabel(filter: string): string {
    const controlName = this.getControlName(filter);
    if (!controlName) return '';
    const raw = this.searchUserForm?.controls?.[controlName]?.value;
    return multiSelectAllTriggerLabel(
      raw,
      this.formDetails?.[filter],
      this.ALL_TOKEN
    );
  }

  onAllOptionSelectionChange(change: MatOptionSelectionChange, filter: string) {
    if (!change?.isUserInput) return;
    const controlName = this.getControlName(filter);
    if (!controlName) return;

    const allValues = this.getAllValues(filter);
    const control = this.searchUserForm.controls[controlName];
    if (!control) return;

    if (change.source.selected) {
      control.setValue([this.ALL_TOKEN, ...allValues], { emitEvent: false });
      this.data = { type: filter, value: [this.ALL_TOKEN] };
      this.filterEmit$.next(this.data);
      this.scheduleAllMatOptionSync(filter);
    } else {
      control.setValue([], { emitEvent: false });
      this.data = { type: filter, value: [] };
      this.filterEmit$.next(this.data);
      this.scheduleAllMatOptionSync(filter);
    }
  }

  private expandAllSelectionsIfNeeded() {
    this.expandAllFor('product_group');
    this.expandAllFor('channel');
    this.expandAllFor('certification');
    this.expandAllFor('bill_to_name');
    this.expandAllFor('ecc');
    this.expandAllFor('main_region');
    this.expandAllFor('part_number');
  }

  private expandAllFor(filter: string) {
    const controlName = this.getControlName(filter);
    if (!controlName) return;
    const control = this.searchUserForm?.controls?.[controlName];
    if (!control) return;

    const current: string[] = control.value || [];
    const allValues = this.getAllValues(filter);
    if (allValues.length === 0) return;

    // Only act on "All" mode (the value carries the "All" token). When another filter
    // changes, dependent dropdowns get a fresh option list; re-expand so the trigger
    // keeps showing "All" and every current option stays checked. Genuine partial
    // selections (no "All" token) are left untouched.
    if (!current.includes(this.ALL_TOKEN)) return;

    const target = [this.ALL_TOKEN, ...allValues];
    if (this.arraysEqual(current, target)) return;

    control.setValue(target, { emitEvent: false });
    this.scheduleAllMatOptionSync(filter);
  }

  /** Mat-select can leave the extra "All" row ticked after patchValue; sync after the next paint. */
  private scheduleAllMatOptionSync(filter: string): void {
    const run = () => {
      this.applyAllMatOptionSync(filter);
      this.cdr.detectChanges();
    };
    setTimeout(run, 0);
    setTimeout(run, 16);
    setTimeout(run, 64);
  }

  /** True when the form value represents every option (expanded "All" or lone All before expand). */
  private shouldAllMatOptionBeSelected(
    filter: string,
    controlValue: string[]
  ): boolean {
    const allVals = this.getAllValues(filter);
    if (!controlValue?.length) return false;
    if (allVals.length === 0) {
      return controlValue.length === 1 && controlValue[0] === this.ALL_TOKEN;
    }
    if (controlValue.length === 1 && controlValue[0] === this.ALL_TOKEN) {
      return true;
    }
    return (
      controlValue.includes(this.ALL_TOKEN) &&
      controlValue.length === allVals.length + 1
    );
  }

  private applyAllMatOptionSync(filter: string): void {
    const controlName = this.getControlName(filter);
    if (!controlName) return;
    const controlValue =
      (this.searchUserForm?.controls?.[controlName]?.value as string[]) ?? [];
    const wantSelect = this.shouldAllMatOptionBeSelected(filter, controlValue);
    const matSelect = this.getMatSelectForFilter(filter);
    if (matSelect?.options?.length) {
      matSelect.options.forEach((opt) => {
        if (opt.value !== this.ALL_TOKEN) return;
        if (wantSelect) {
          if (!opt.selected) opt.select();
        } else if (opt.selected) {
          opt.deselect();
        }
      });
      return;
    }
    const opt = this.getAllMatOption(filter);
    if (!opt) return;
    if (wantSelect) {
      if (!opt.selected) opt.select();
    } else if (opt.selected) {
      opt.deselect();
    }
  }

  /** If "All" is in the value but not every option is selected, drop the token. */
  private collapsePartialAllToken(
    controlValue: string[],
    allValues: string[]
  ): string[] {
    if (!Array.isArray(controlValue) || allValues.length === 0) {
      return Array.isArray(controlValue) ? [...controlValue] : [];
    }
    if (!controlValue.includes(this.ALL_TOKEN)) {
      return [...controlValue];
    }
    const nonAll = controlValue.filter((v) => v !== this.ALL_TOKEN);
    // Lone ["All"] means "all selected" (not yet expanded); never strip it to [].
    if (nonAll.length > 0 && nonAll.length < allValues.length) {
      return [...nonAll];
    }
    return [...controlValue];
  }

  private deriveEmittedMulti(
    controlValue: string[],
    filter: string
  ): string[] {
    if (this.shouldAllMatOptionBeSelected(filter, controlValue)) {
      return [this.ALL_TOKEN];
    }
    return controlValue.filter((v) => v !== this.ALL_TOKEN);
  }

  private getMatSelectForFilter(filter: string): MatSelect | null {
    switch (filter) {
      case 'product_group':
        return this.productGroupSelect ?? null;
      case 'channel':
        return this.channelSelect ?? null;
      case 'certification':
        return this.certificationSelect ?? null;
      case 'bill_to_name':
        return this.billToNameSelect ?? null;
      case 'ecc':
        return this.ddsPdcOhtersSelect ?? null;
      case 'part_number':
        return this.partNumberSelect ?? null;
      default:
        return null;
    }
  }

  private getAllMatOption(filter: string): MatOption | null {
    switch (filter) {
      case 'product_group':
        return this.allProductGroupSelected ?? null;
      case 'channel':
        return this.allChannelSelected ?? null;
      case 'certification':
        return this.allCustomerGroupSelected ?? null;
      case 'bill_to_name':
        return this.allProductCategorySelected ?? null;
      case 'ecc':
        return this.allDDSPDCOthersSelected ?? null;
      case 'main_region':
        return this.allRegionSelected ?? null;
      case 'part_number':
        return this.allPartsSelected ?? null;
      default:
        return null;
    }
  }

  private getControlName(filter: string): string | null {
    switch (filter) {
      case 'product_group':
        return 'userProductGroup';
      case 'channel':
        return 'userChannel';
      case 'certification':
        return 'userCustomerGroup';
      case 'bill_to_name':
        return 'userProductCategory';
      case 'ecc':
        return 'userDDSPDCOthers';
      case 'main_region':
        return 'userRegion';
      case 'part_number':
        return 'userParts';
      default:
        return null;
    }
  }

  private getAllValues(filter: string): string[] {
    const list = this.formDetails?.[filter];
    if (!Array.isArray(list)) return [];
    return list
      .map((i: any) => i?.value)
      .filter((v: any) => typeof v === 'string' && v !== this.ALL_TOKEN);
  }

  private normalizeSelection(
    raw: string[],
    allValues: string[]
  ): { controlValue: string[]; emittedValue: string[] } {
    const hasAll = raw.includes(this.ALL_TOKEN);

    if (hasAll && raw.length === 1) {
      return {
        controlValue: [this.ALL_TOKEN, ...allValues],
        emittedValue: [this.ALL_TOKEN],
      };
    }

    if (hasAll && raw.length > 1 && raw.length < allValues.length + 1) {
      const subset = raw.filter((v) => v !== this.ALL_TOKEN);
      return { controlValue: subset, emittedValue: subset };
    }

    const withoutAll = raw.filter((v) => v !== this.ALL_TOKEN);
    if (!hasAll && allValues.length > 0 && withoutAll.length === allValues.length) {
      return {
        controlValue: [this.ALL_TOKEN, ...allValues],
        emittedValue: [this.ALL_TOKEN],
      };
    }

    if (hasAll && raw.length === allValues.length + 1) {
      return {
        controlValue: [this.ALL_TOKEN, ...allValues],
        emittedValue: [this.ALL_TOKEN],
      };
    }

    return { controlValue: withoutAll, emittedValue: withoutAll };
  }

  private arraysEqual(a: string[], b: string[]) {
    if (a === b) return true;
    if (!Array.isArray(a) || !Array.isArray(b)) return false;
    if (a.length !== b.length) return false;
    const sa = [...a].sort();
    const sb = [...b].sort();
    for (let i = 0; i < sa.length; i++) {
      if (sa[i] !== sb[i]) return false;
    }
    return true;
  }
 

  loadMore(event) {
    const page = event;
    this.qparam = {
      product_group: this.selectedValues.product_group,
      channel: this.selectedValues.channel,
      certification: this.selectedValues.certification,
      bill_to_name: this.selectedValues.bill_to_name,
      ecc: this.selectedValues.ecc,
      main_region: this.selectedValues.main_region,
      current_dropdown: 'parts',
    };
    if (event == 'add') {
      this.page = this.page + 1;
    } else {
      {
        this.page = this.page - 1;
      }
    }
    this.service
      .getPartsDropdown(this.qparam, this.page, this.size)
      .subscribe((results) => {
        let channel: any[] = [];
        channel = results.parts;
        const resp = [...new Set(channel)];
        if (resp.length == 0) {
          this.more = false;
        } else {
          this.more = true;
        }
        this.formDetails['part_number'] =
          resp && resp.map((i: string) => ({ viewValue: i, value: i }));
        // this.filteredPartsMulti.next(this.formDetails['parts']);
      });
  }
  onPartsRemoved(event) {
    const index = this.selectedValues.parts.indexOf(event);
    let x = this.selectedValues.parts.splice(index, 1);
    this.searchUserForm.controls.userEcc.patchValue(this.selectedValues.parts);
    this.cdr.detectChanges();
  }

  onLoadClick() {
    this.loadMoreClk = true;
    }
}
